import { HttpResponse, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { IpawsAgency, IpawsApi, ListIpawsAgenciesResponse } from "src/app/hickory-api";
import { mockHandler } from "../mock.handler";

export const MOCK_AGENCIES: IpawsAgency[] = [
  {
    id: 1000,
    name: 'Agency_1000'
  },
  {
    id: 1001,
    name: 'Agency_1001'
  },
  {
    id: 1002,
    name: 'Agency_1002'
  },
  {
    id: 1003,
    name: 'Agency_1003'
  }
];

export class MockIpawsApi extends IpawsApi {
  public readonly agencies = MOCK_AGENCIES
  override getIpawsAgencies(observe?: "body", reportProgress?: boolean, options?: { httpHeaderAccept?: "application/json"; }): Observable<ListIpawsAgenciesResponse>;
  override getIpawsAgencies(observe?: "response", reportProgress?: boolean, options?: { httpHeaderAccept?: "application/json"; }): Observable<HttpResponse<ListIpawsAgenciesResponse>>;
  override getIpawsAgencies(observe?: "events", reportProgress?: boolean, options?: { httpHeaderAccept?: "application/json"; }): Observable<HttpEvent<ListIpawsAgenciesResponse>>;
  override getIpawsAgencies(observe?: any, reportProgress?: boolean, options?: { httpHeaderAccept?: "application/json"; }): Observable<any> {
    return mockHandler(<ListIpawsAgenciesResponse>{ items: this.agencies })
  }
}